import { useCallback } from 'react';

import { useIsBreakdownMode } from './useChartIsBreakdownMode';
import { useChartState } from './useChartState';

export const useMetricChart = () => {
  const isChartBreakdownMode = useIsBreakdownMode();
  const chartState = useChartState();

  const getMetricChart = useCallback(
    ({ id, index }) => {
      const mixedTypes =
        chartState.chartViewSettings[
          isChartBreakdownMode ? 'breakdownMixedTypes' : 'metricMixedTypes'
        ];

      if (chartState?.chartViewSettings?.type === 'mixed') {
        let currentMixedType;
        if (id) {
          currentMixedType = mixedTypes.find(
            (mixedType) => mixedType.id === id
          );
        }

        if (!currentMixedType) {
          currentMixedType = mixedTypes[index];
        }

        return {
          label: currentMixedType?.label,
          type: currentMixedType?.type || 'line',
        };
      }

      return {
        label: chartState?.chartViewSettings?.label,
        type: chartState?.chartViewSettings?.type,
      };
    },
    [isChartBreakdownMode, chartState.chartViewSettings]
  );
  return getMetricChart;
};
